import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost, appContextPut } from './httpCommon/appAxios.service';
import { ShippingPaymentTransaction, StandardParams } from '../types/interfaces';
import { PAYMENT_TRANSACTION_API_ENDPOINTS } from '../constants/apiEndpoints';

export const getShippingPaymentTransactions = (
  params?: StandardParams,
): Promise<AxiosResponse<ShippingPaymentTransaction[], any>> => {
  return appContextGet(PAYMENT_TRANSACTION_API_ENDPOINTS.SHIPPING_PAYMENT_TRANSACTIONS, params);
};

export const updateShippingPaymentTransactions = (shippingPaymentId: number, payload: {}): Promise<AxiosResponse<any, any>> => {
  return appContextPut(PAYMENT_TRANSACTION_API_ENDPOINTS.SHIPPING_PAYMENT_TRANSACTIONS_ + shippingPaymentId, payload);
};

export const addShippingPaymentTransactions = (payload: {}): Promise<AxiosResponse<any, any>> => {
  return appContextPost(PAYMENT_TRANSACTION_API_ENDPOINTS.SHIPPING_PAYMENT_TRANSACTIONS, payload);
};
